export default "__VITE_ASSET__DWeSnfRt__"